<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <ODateInput v-model="model" :placeholder="placeholder" :disabled="normalizedDisabled" :editable="editable"
        :clearable="clearable" :format="format" :sourceFormat="sourceFormat" @change="(attrs.onChange)"></ODateInput>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormDateInputProps } from './DateInput'
import ODateInput from '../../Input/DateInput/DateInput.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormDate', inheritAttrs: false })
const attrs = useAttrs()

const {
  name,
  label,
  labelWidth,
  required,
  placeholder,
  editable = true,
  clearable = true,
  format = 'YYYY-MM-DD',
  sourceFormat,
} = defineProps<FormDateInputProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
